import { type RouteLocationNormalized } from 'vue-router'
import { useNavStore } from '@/stores/system/nav.ts'

export const addRouteToHistory = (route: RouteLocationNormalized) => {
	const navStore = useNavStore()
	navStore.addRouteToHistory(route)
}
